import React from 'react';
import Image from 'next/image';

import {Text} from '#component/base';
import {useViewportSize} from '#hook';

import * as css from './PricedProductVariantRow.css';

export interface PricedProductVariantRowProps {
  image: string;
  title: string;
  value: number;
  discount: number | undefined;
  plusSupplement: string | undefined;
  display: boolean | undefined;
}

export const PricedProductVariantRow = ({
  image,
  title,
  value,
  discount,
  plusSupplement,
  display,
}: PricedProductVariantRowProps) => {
  const {isDesktop} = useViewportSize();
  const imageSize = isDesktop ? 80 : 60;

  const valueWithDiscount = discount ? (value - discount).toFixed(2) : value;
  const isDiscounted = discount ? discount > 0 : false;
  const textColor = isDiscounted ? 'dustyGray' : 'doveGray';

  // If the product variant is not meant to be displayed in its own row
  // (for example, a supplement that is added on to a Membership, "with Vitality"),
  // this component is not rendered
  if (!display) {
    return null;
  }

  return (
    <div className={css.ProductVariantRowContainer}>
      <div className={css.ImageWrapper}>
        <Image width={imageSize} height={imageSize} src={image} alt={title} />
      </div>
      <div className={css.TitleWrapper}>
        <Text variant="heading4" className={css.TextTitleStyles} color="burgundy">
          {title}
        </Text>
        {plusSupplement && (
          <div>
            <Text style={{fontSize: '15px', color: textColor}}>with {plusSupplement}</Text>
          </div>
        )}
      </div>
      <div>
        <Text
          color={textColor}
          className={`${isDiscounted ? css.LineThrough : ''} ${css.TextValueStyles}`}>
          ${value}
        </Text>
        {isDiscounted && (
          <Text className={css.TextValueStyles} color="eggplant">
            {' '}
            ${valueWithDiscount}/mo
          </Text>
        )}
        {!isDiscounted && (
          <Text className={css.TextValueStyles} color={textColor}>
            /mo
          </Text>
        )}
      </div>
    </div>
  );
};
